import { render, staticRenderFns } from "./CY_TotalPrice.vue?vue&type=template&id=2a6f1492&scoped=true"
import script from "./CY_TotalPrice.vue?vue&type=script&lang=js"
export * from "./CY_TotalPrice.vue?vue&type=script&lang=js"
import style0 from "./CY_TotalPrice.vue?vue&type=style&index=0&id=2a6f1492&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a6f1492",
  null
  
)

export default component.exports